import React from 'react';

import Link from '@components/i18n/Link';
import { useAnalytics } from '@utils/analytics';

const AnalyticsLink = ({
  gaType,
  gaText,
  gaDestination,
  gaComponent,
  children,
  ...rest
}) => {
  const { trackInteraction } = useAnalytics();

  if (gaDestination === undefined) {
    gaDestination = rest.to || rest.href;
  }

  if (/^tel:/m.test(gaDestination)) {
    gaType = 'phone';
  }

  const onClick = e => {
    if (!gaText) {
      gaText = e?.target.innerText;
    }

    if (gaType && gaText) {
      trackInteraction(gaType, gaText, gaDestination, gaComponent);
    }
  };

  const componentProps = {
    ...rest,
    to: gaDestination,
    onClick: e => onClick(e),
  };

  return <Link {...componentProps}>{children}</Link>;
};

export default AnalyticsLink;
